import React, { useState } from 'react';
import { getMatchStreamingProps } from '../../data/streaming/streamingUtils';
import { iconCategoryCssClass } from '../../data/utils/iconCategoryCssClass';
import { iconSportCssClass } from '../../data/utils/iconSportCssClass';
import { LiveContext } from '../Live';
import LiveTournamentMatch from '../tournament/LiveTournamentMatch';

function FavoritesSport(props) {
    const liveContext = React.useContext(LiveContext);
    const [toggled, setToggled] = useState(true);

    let elementsList = null;
    if (liveContext.sortType === 'league') {
        elementsList = props.tournaments.map((tournamentMatches, i) => {
            const firstMatch = tournamentMatches[0];
            let icon = null;
            if (firstMatch.categoryRef === 0) {
                icon = iconCategoryCssClass(1, 4);
            } else {
                icon = iconCategoryCssClass(firstMatch.sportRef, firstMatch.categoryRef, firstMatch.iconClass);
            }
            return (
                <React.Fragment key={i}>
                    <div className="heading">
                        <span className="text-medium push-left push-right">{firstMatch.tournamentDesc}</span>
                        <span className={`border img-fluid ico-cat iconCategoryLive ${icon}`}></span>
                    </div>
                    {tournamentMatches.map((match, i) => {
                        const streamingMap = getMatchStreamingProps(match);
                        return <LiveTournamentMatch key={match.uniqueId} match={match} aggregata={match.idAggregata} streaming={streamingMap && streamingMap[match.id]}  />;
                    })}
                </React.Fragment>
            )
        });
    } else {
        elementsList = props.matches.sort((m1, m2) => {
            if (liveContext.sortType === 'asc') {
                return m1.timestampDB.localeCompare(m2.timestampDB);
            } else {
                return m2.timestampDB.localeCompare(m1.timestampDB);
            }
        }).map(match => {
            const streamingMap = getMatchStreamingProps(match);
            return <LiveTournamentMatch key={match.uniqueId} match={match} aggregata={match.idAggregata} streaming={streamingMap && streamingMap[match.id]}  />;
        });
    }

    return (
        <>
            <div className="list-element sport-collapse" onClick={() => setToggled(!toggled)}>
                <div className={`prematch-sport-img big ${iconSportCssClass(props.tournaments[0][0].sportRef)}`}></div>
                <span className="list-element-text list-heading">{props.tournaments[0][0].sportDesc}</span>
                <span className="push-right list-element-info"></span>
            </div>
            {toggled &&
                <>
                    {elementsList}
                </>
            }
        </>
    );
}

export default FavoritesSport;